import { render } from "./GamificationDashboard.vue?vue&type=template&id=9ab8bf9e&scoped=true"
import script from "./GamificationDashboard.vue?vue&type=script&lang=js"
export * from "./GamificationDashboard.vue?vue&type=script&lang=js"

import "./GamificationDashboard.vue?vue&type=style&index=0&id=9ab8bf9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab8bf9e"]])

export default __exports__